module.exports = __webpack_public_path__ + "img/logo-light.e3b530a1.png";